﻿window.toggleFunc = function () {
    var instance = {
        toggle: function (source) {
            var checkboxes = $(source).parent().find('input[type="checkbox"]');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i] !== source)
                    checkboxes[i].checked = source.checked && !checkboxes[i].disabled;
            }
        },
        checkboxClick: function(source, allCheck) {
            if(!source.checked) {
                allCheck.checked = false;
            }
            else {
                var checkboxes = $(source).parent().find('input[type="checkbox"]');
                var noChecked = 0;
                for (var i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i] !== source && checkboxes[i] !== allCheck && !checkboxes[i].checked && !checkboxes[i].disabled) {
                        noChecked++;
                    }
                }
                if(noChecked === 0) {
                    allCheck.checked = true;
                }
            }
        }
    }
    return instance;
}();

window.ctrl_info_ti_replacearchcomm = function () {
    var instance = {
        widgetDidMount: function (state) {
        	var pp = document.getElementById(state.root + '_pp');
            pp.addEventListener('keydown', function (e) {
                var res = document.getElementById(state.root + '_result');
                res.innerHTML = '';
            });
        }
    }
    return instance;
}();

window.ctrl_Info_TI_ReplaceArchComm_PreviousDay = function () {
    var instance = {
        widgetDidMount: function (state) {
            var pp = document.getElementById(state.root + '_pp2');
            pp.addEventListener('keydown', function (e) {
                var res = document.getElementById(state.root.replace('_algoparms', '') + '_result');
                res.innerHTML = '';
            });
            pp.addEventListener('change', function (e) {
                var res = document.getElementById(state.root.replace('_algoparms', '') + '_result');
                res.innerHTML = '';
            });
        }
    }
    return instance;
}();

window.ctrl_Info_TI_ReplaceArchComm_FeelValues = function () {
    var instance = {
        widgetDidMount: function (state) {
            var pp = document.getElementById(state.root + '_insertedvalue');
            pp.addEventListener('keydown', function (e) {
                var res = document.getElementById(state.root.replace('_algoparms', '') + '_result');
                res.innerHTML = '';
            });
        }
    }
    return instance;
}();

window.ctrl_Info_TI_ReplaceArchComm_Even = function () {
    var instance = {
        widgetDidMount: function (state) {
            var pp = document.getElementById(state.root + '_sumvalue');
            pp.addEventListener('keydown', function (e) {
                var res = document.getElementById(state.root.replace('_algoparms', '') + '_result');
                res.innerHTML = '';
            });
        }
    }
    return instance;
}();

window.ctrl_Info_TI_ReplaceArchComm_ActUndercount = function () {
    var instance = {
        widgetDidMount: function (state) {
            var pp = document.getElementById(state.root + '_sumvalue');
            pp.addEventListener('keydown', function (e) {
                var res = document.getElementById(state.root.replace('_algoparms', '') + '_result');
                res.innerHTML = '';
            });
        }
    }
    return instance;
}();

window.ctrl_Info_TI_ReplaceArchComm_FSKFrom80020 = function () {
    var instance = {
        widgetDidMount: function (state) {
            this.root = state.root;
            var fileUpload = document.getElementById(state.root + '_file');
            if (fileUpload)
                fileUpload.addEventListener('change', function (e) {
                    if (fileUpload.files.length > 0)
                        document.getElementById(state.root + '_upload').disabled = false;                    
                });
        },
        ticodeChanged: function (ticode) {
            var ai = document.getElementById(this.root + '_channeltypes_ai');
            var ao = document.getElementById(this.root + '_channeltypes_ao');
            var ri = document.getElementById(this.root + '_channeltypes_ri');
            var ro = document.getElementById(this.root + '_channeltypes_ro');
            ai.disabled = ticode.options[ticode.selectedIndex].getAttribute('ch1') != '1';
            ao.disabled = ticode.options[ticode.selectedIndex].getAttribute('ch2') != '1';
            ri.disabled = ticode.options[ticode.selectedIndex].getAttribute('ch3') != '1';
            ro.disabled = ticode.options[ticode.selectedIndex].getAttribute('ch4') != '1';
            if (ai.disabled) ai.checked = false;
            if (ao.disabled) ao.checked = false;
            if (ri.disabled) ri.checked = false;
            if (ro.disabled) ro.checked = false;
            document.getElementById(this.root + '_all_ch').checked =
                (ai.checked || ai.disabled) &&
                (ao.checked || ao.disabled) &&
                (ri.checked || ri.disabled) &&
                (ro.checked || ro.disabled) &&
                (ai.checked || ao.checked || ri.checked || ro.checked);
        }
    }
    return instance;
}();

window.replacearchcommtable = function (cu) {
    const cantsetreason = 'cantsetreason';
    const diffstatus = 'diffstatus';
    var instance = {
        widgetDidMount: function (state) {
            const root = document.getElementById(state.root);
            const values = root.querySelectorAll('input[type="text"]');

            for (var i = 0; i < values.length; i++) {
            	const el = values[i];
            	el.addEventListener('focus', function (e) {
            		e.currentTarget.setSelectionRange(0, e.currentTarget.value.length);
            	});
                el.addEventListener('change', function (e) {
                    const t = e.currentTarget;
                    if (t.value == '') t.value = t.getAttribute('data-orig');
                    var cantsetreasoncng = 0;
                    const row = t.parentNode.parentNode;
                    if (!row.classList.contains(diffstatus)) {
                        if (t.getAttribute('data-orig') != t.value) {
                            t.classList.add('changed')
                            if (row.classList.contains(cantsetreason))
                                cantsetreasoncng = -1;
                            row.classList.remove(cantsetreason);

                            if (t.getAttribute("autocheck") == "true")
                                row.querySelector('input[type="checkbox"]').checked = true;
                        }
                        else {
                            t.classList.remove('changed');
                            if (!row.classList.contains(cantsetreason))
                                cantsetreasoncng = 1;
                            row.classList.add(cantsetreason);
                            if (t.getAttribute("autocheck") == "true")
                                row.querySelector('input[type="checkbox"]').checked = false;
                        }
                    }
                    const sums = calcSum(t);
                    const row0 = sums.sum0.parentNode.parentNode;
                    const row0cantsetreasoncnt = parseInt(row0.getAttribute('data-cantsetreasoncnt')) + cantsetreasoncng;
                    row0.setAttribute('data-cantsetreasoncnt', row0cantsetreasoncnt);
                    if (row0cantsetreasoncnt > 0)
                        row0.classList.add('orangecheckbox');
                    else
                        row0.classList.remove('orangecheckbox');

                    const row1 = sums.sum1.parentNode.parentNode;
                    const row1cantsetreasoncnt = parseInt(row1.getAttribute('data-cantsetreasoncnt')) + cantsetreasoncng
                    row1.setAttribute('data-cantsetreasoncnt', row1cantsetreasoncnt);
                    if (row1cantsetreasoncnt > 0)
                        row1.classList.add('orangecheckbox');
                    else
                        row1.classList.remove('orangecheckbox');
                });
                el.addEventListener('paste', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    const t = e.currentTarget;
                    var data = getClipboardData(e).split('\n');

                    var cur = t;
                    var tr = getRow(cur);
                    var b = true;

                    for (var i = 0; i < data.length && b; i++) {
                        if (data[i] == '') continue;
                        if (!cur.disabled) {
                            cur.value = data[i];

                            var evt = document.createEvent("HTMLEvents");
                            evt.initEvent("change", false, true);
                            cur.dispatchEvent(evt);

                            var kevt = document.createEvent("HTMLEvents");
                            kevt.initEvent("keyup", false, true);
                            cur.dispatchEvent(kevt);
                        }
                        do {
                            tr = tr.nextElementSibling;
                            b = tr && tr instanceof HTMLTableRowElement;
                            if (b) cur = tr.querySelector('input[type="text"]');
                        } while (!cur && b)
                    }
                });
            }

            function calcSum(el) {
                const col = el.getAttribute('data-col');
                const id = el.getAttribute('data-id');
                if (!id)
                    return;
                var val = parseFloat(el.value.replace(/[^0-9\.,-]/g, '').replace(',', '.'));

                if (isNaN(val))
                    val = 0;

                const prevVal = el.getAttribute('data-prev')?.replace(/[^0-9\.,-]/g, '').replace(',', '.');
                var dataOrig = el.getAttribute('data-orig')?.replace(/[^0-9\.,-]/g, '').replace(',', '.');
                var origVal = parseFloat(prevVal ?? dataOrig);
                if (isNaN(origVal)) origVal = 0;
                if (el.skip) {
                    origVal = prevVal ?? val;
                    val = parseFloat(dataOrig);
                    if (isNaN(val)) val = 0;
                }
                el.setAttribute('data-prev', val);
                
                const sum0 = document.querySelector('.colsum[data-col="' + col + '"][data-id="0-' + id.substr(0, 6) + '"]');
                var sum0val = parseFloat(sum0.getAttribute('data-orig')?.replace(/[^0-9\.,-]/g, '').replace(',', '.'));
                if (isNaN(sum0val)) sum0val = 0;

                const sum1 = document.querySelector('.colsum[data-col="' + col + '"][data-id="1-' + id + '"]');
                var sum1val = parseFloat(sum1.getAttribute('data-orig')?.replace(/[^0-9\.,-]/g, '').replace(',', '.'));
                if (isNaN(sum1val)) sum1val = 0;

                const newSum0 = sum0val - origVal + val;
                const newSum1 = sum1val - origVal + val;

                sum0.setAttribute('data-orig', newSum0);
                sum0.innerHTML = newSum0.toLocaleString('ru-RU', { minimumFractionDigits: 3 })
                sum1.setAttribute('data-orig', newSum1);
                sum1.innerHTML = newSum1.toLocaleString('ru-RU', { minimumFractionDigits: 3 })

                return { sum0, sum1 };
            }

            function initInputForCheckbox(el, disabledState) {
            	const tr = el.parentNode.parentNode;
                const inputs = tr.querySelectorAll('input[type="text"],input[type="hidden"]:not([name^="restricted_"])');
            	for (var i = 0, len = inputs.length; i < len; i++) {
                    inputs[i].disabled = disabledState || inputs[i].readOnly;
                    inputs[i].skip = disabledState;
                    if (!disabledState && inputs[i].getAttribute('data-prev') == null)
                        inputs[i].setAttribute('data-prev', inputs[i].value);
                    calcSum(inputs[i]);
                }
            }

            function setCheckBoxState(el, state) {
            	const tr = getRow(el);
            	const level = parseInt(tr.getAttribute('data-level'));
            	var row = tr.nextElementSibling;
            	while (row && parseInt(row.getAttribute('data-level')) > level) {
                    const cb = row.querySelector('input[type="checkbox"]');
                    if (cb && cb.classList.contains("type-ch") && !cb.disabled) {
            			cb.checked = state;
            			initInputForCheckbox(cb, !state);
                    }

                    if ((cb && !cb.disabled && cb.classList.contains("type-ch")) && row.querySelectorAll("div[data-reason-current]").length==0) {
                        if (cb.checked)
                            row.classList.remove("cantsetreason");
                        else if (!row.classList.contains("cantsetreason"))
                            row.classList.add("cantsetreason");

                    }

            		row = row.nextElementSibling;
            	}
            }

            function massCheck(e, cls, checkFunc) {
                const curCb = e.currentTarget;
                const curTr = curCb.parentNode.parentNode;

                if (e.shiftKey) {
                    const actCb = document.activeElement;
                    const actTr = actCb.parentNode.parentNode;

                    if (curCb.getAttribute('data-g1') == actCb.getAttribute('data-g1') &&
                        curCb.getAttribute('data-drl') == 2 && actCb.getAttribute('data-drl') == 2) {
                        var tr = curTr.rowIndex >= actTr.rowIndex ? actTr : curTr.nextElementSibling;
                        const cnt = Math.abs(curTr.rowIndex - actTr.rowIndex);

                        for (var j = 0; j < cnt; j++) {
                            const el = tr.querySelector('input[type="checkbox"].' + cls);
                            if (!el.disabled)
                                el.checked = curCb.checked;
                            if (checkFunc)
                                checkFunc(el, curCb.checked);                                 

                            if (tr.querySelectorAll("div[data-reason-current]").length == 0) {
                                if (!el.disabled) {
                                    if (curCb.checked)
                                        tr.classList.remove(cantsetreason);
                                    else
                                        tr.classList.add(cantsetreason);
                                }

                            }
                            tr = tr.nextElementSibling;
                        }
                    }
                }
                curCb.focus();
            }

            const checkboxes = root.querySelectorAll('input[type="checkbox"]');
            for (var i = 0; i < checkboxes.length; i++) {
                const el = checkboxes[i];
                const drl = el.getAttribute("data-drl");

                if (el.classList.contains("type-ch")) {

                    if (!el.checked)
                        initInputForCheckbox(el, !el.checked);

                    el.addEventListener('mousedown', function (e) {
                        e.preventDefault();
                    });
                    el.addEventListener('click', function (e) {
                        initInputForCheckbox(e.currentTarget, !e.currentTarget.checked);

                        massCheck(e, 'type-ch', (curEl, val) => {
                            initInputForCheckbox(curEl, !val);
                        });
                        const t = e.currentTarget;
                        const row = t.parentNode.parentNode;
                        if (row.querySelectorAll("div[data-reason-current]").length == 0) {
                            if (t.checked)
                                row.classList.remove(cantsetreason);
                            else
                                row.classList.add(cantsetreason);
                        }
                    });
                }
                else if (el.classList.contains("type-reason") && drl != "2") {
                    const cbGroupSelector = x => 'input[type="checkbox"][class="type-reason"][data-g' + drl + '="' + x.getAttribute("data-g" + drl) + '"]:not([data-drl="0"])';
                    const cbGroup = root.querySelectorAll(cbGroupSelector(el));
                    var cantsetreasonCnt = 0;
                    cbGroup.forEach(function (cb) {
                        if (cb.disabled || cb.parentNode.parentNode.classList.contains(cantsetreason))
                            cantsetreasonCnt++;
                    });
                    el.parentNode.parentNode.setAttribute('data-cantsetreasoncnt', cantsetreasonCnt);
                    if (cantsetreasonCnt > 0)
                        el.parentNode.parentNode.classList.add('orangecheckbox');

                    el.addEventListener('click', function (e) {
                        const gr = root.querySelectorAll(cbGroupSelector(e.target));
                        gr.forEach(function (cb) {
                            cb.checked = e.target.checked;
                        });
                    });
                }
                else if (el.classList.contains("type-reason") && drl == "2") {
                    el.addEventListener('mousedown', function (e) {
                        e.preventDefault();
                    });
                    el.addEventListener('click', function (e) {
                        massCheck(e, 'type-reason');
                    });
                }
            }

            const selectallbtns = root.querySelectorAll('.action-selectall');
            for (var i = 0; i < selectallbtns.length; i++) {
                const el = selectallbtns[i];
                el.addEventListener('click', function (e) {
                	setCheckBoxState(el, true);
                });
            }

            const clearallbtns = root.querySelectorAll('.action-clearall');
            for (var i = 0; i < clearallbtns.length; i++) {
                const el = clearallbtns[i];
                el.addEventListener('click', function (e) {
                	setCheckBoxState(el, false);
                });
            }

            var filedsCollection = document.getElementsByClassName("decimalvtmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = getClipboardData(e).replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatevt(e, valuetovalidate, state.root, allowNegative);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = e.target.value.replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatevt(e, valuetovalidate, state.root, allowNegative);
                };
            }

            // Для редактирования таможенного профиля
            filedsCollection = document.getElementsByClassName("decimaltpmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = getClipboardData(e).replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatetp(e, valuetovalidate, state.root, allowNegative);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = e.target.value.replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatetp(e, valuetovalidate, state.root, allowNegative);
                };
            }
            ///

            filedsCollection = document.getElementsByClassName("decimalkvmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = getClipboardData(e).replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatekv(e, valuetovalidate, state.root, allowNegative);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = e.target.value.replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatekv(e, valuetovalidate, state.root, allowNegative);
                };
            }

            filedsCollection = document.getElementsByClassName("decimalmvtmask");
            for (var i = 0; i < filedsCollection.length; i++) {
                filedsCollection[i].onpaste = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    const valuetovalidate = getClipboardData(e).replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatemvt(e, valuetovalidate, state.root, allowNegative);
                };
                filedsCollection[i].onkeyup = function (e) {
                    var allowNegative = e.target.getAttribute("data-allowNegative") == 'True';
                    var valuetovalidate = e.target.value.replace(",", ".").replace(" ", "").replace(/\u00a0/g, "");
                    validate_input.validatemvt(e, valuetovalidate, state.root, allowNegative);
                };
            }

            listview.initFixedHeader(root);
        }
    };

    function getClipboardData(e) {
        if (window.clipboardData && window.clipboardData.getData) {
            return window.clipboardData.getData('Text');
        } else if (e.clipboardData && e.clipboardData.getData) {
            return e.clipboardData.getData('text/plain');
        }
    }
    function getRow(caller) {
        return cu.getThisOrParent(caller, function (el) { return el instanceof HTMLTableRowElement; });
    };

    return instance;
}(commonUtils);

window.validate_input = function () {

    var instance = {
        validatevt: allowInt1000,
        // MS-4130 Для введенных пользователем значений должна выполняться проверка корректности ввода (только числа, целые или дробные).
        validatetp: allowNumeric,
		validatekv: allowInt,
		validatemvt: allowNumeric
	};

    const isNumeric = /^(\d+|\d+\.\d*|\d*\.\d+)$/;
    const isNumericNegative = /^[-+]?[0-9]*[.]?[0-9]+(?:[eE][-+]?[0-9]+)?$/;

    function isNumericCheck(value, allowNegative) {
        var checkRegexValue = false;
        if (allowNegative)
            checkRegexValue = isNumericNegative.test(value);
        else
            checkRegexValue = isNumeric.test(value);
        return checkRegexValue;
    }

	function allowNumeric(e, value, _id, allowNegative) {
		var id = _id.replace("_data", "");
        var n = parseFloat(value) * 1000;

        if (value == "" || (isNumericCheck(value, allowNegative) && n == Math.round(n))) {
			enablebutton(id, e);
		}
		else {
			disablebutton(id, e);
		}
	}

    function allowInt(e, value, _id, allowNegative) {
		var id = _id.replace("_data", "");
		var n = parseFloat(value);
        if (value == "" || (isNumericCheck(value, allowNegative) && n == Math.round(n))) {
			enablebutton(id, e);
		}
		else {
			disablebutton(id, e);
		}
	}

    function allowInt1000(e, value, _id, allowNegative) {
		var id = _id.replace("_data", "");
		var n = parseFloat(value) / 1000;
        if (value == "" || (isNumericCheck(value, allowNegative) && n == Math.round(n))) {
			enablebutton(id, e);
		}
		else {
			disablebutton(id, e);
		}
	}

    function disablebutton(id, e) {
    	document.getElementById(id + "_savebtn").disabled = true;
    	e.target.classList.add("line-through");
    }

    function enablebutton(id, e) {
    	e.target.classList.remove("line-through");
    	var disabledfield = document.getElementsByClassName("line-through");

    	if (disabledfield.length == 0) {
    		document.getElementById(id + "_savebtn").disabled = false;
    	}
    	e.target.classList.remove("line-through");
    }

    return instance;
}();